/* NVRSD — cart discount code box (cart page + cart drawer). */
if (!customElements.get('nvrsd-cart-discount')) {
  customElements.define(
    'nvrsd-cart-discount',
    class NvrsdCartDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.error = this.querySelector('[data-error]');
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const code = this.input.value.trim().toUpperCase();
          if (!code) return;
          this.apply([...this.codes().filter((c) => c !== code), code], code);
        });
        this.querySelectorAll('[data-remove]').forEach((button) =>
          button.addEventListener('click', () => this.apply(this.codes().filter((c) => c !== button.dataset.remove)))
        );
      }

      codes() {
        return (this.dataset.codes || '').split(',').filter(Boolean);
      }

      async apply(codes, added) {
        this.error.hidden = true;
        this.classList.add('is-loading');
        const drawer = this.closest('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
        try {
          const response = await fetch(`${window.routes ? window.routes.cart_update_url : '/cart/update'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(','), sections, sections_url: window.location.pathname }),
          });
          const state = await response.json();
          if (added) {
            const entry = (state.discount_codes || []).find((d) => d.code.toUpperCase() === added);
            if (!entry || !entry.applicable) {
              // Unknown, expired or not combinable with the offers in the cart: take it off again.
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ discount: codes.filter((c) => c !== added).join(',') }),
              });
              return this.showError(`${added} can't be used on this cart. It may not exist, or it can't be combined with the offers already applied.`);
            }
          }
          if (drawer) {
            drawer.renderContents(state);
          } else {
            window.location.reload();
          }
        } catch (e) {
          this.showError('Something went wrong. Please try again.');
        } finally {
          this.classList.remove('is-loading');
        }
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
      }
    }
  );
}
